import EditRubricForm from 'components/Rubrics/EditRubricForm';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { Container, Stack, styled, Text } from 'shell/components';

const Tablet = ({
    form,
    setForm,
    errors,
    setErrors,
    hasClickedSubmit,
    isUnscored,
    validateTitle,
    validateCriteria,
}) => {
    const location = useLocation();
    const { t } = useTranslation('assignment');
    const [mode] = location.pathname.split('/').slice(-1);

    return (
        <CustomContainer device={'tablet'}>
            <RootStack spacing={3}>
                <Text component={'h1'} variant={'h6'} weight={'semibold'}>
                    {mode === 'edit'
                        ? t('rubric.title-edit', 'Edit Rubric')
                        : t('rubric.title-create', 'Create Rubric')}
                </Text>
                <EditRubricForm
                    form={form}
                    setForm={setForm}
                    errors={errors}
                    setErrors={setErrors}
                    hasClickedSubmit={hasClickedSubmit}
                    isUnscored={isUnscored}
                    validateTitle={validateTitle}
                    validateCriteria={validateCriteria}
                />
            </RootStack>
        </CustomContainer>
    );
};

const CustomContainer = styled(Container)(({ theme }) => {
    return {
        paddingBottom: theme.spacing(5),
    };
});

const RootStack = styled(Stack)(() => {
    return {
        width: '100%',
    };
});

export default Tablet;
